module.exports = __webpack_public_path__ + "static/4-d6dd27823357b9d7da30fcc0bf3d679b.png";